import { useLayoutEffect, useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import { CircleChart  } from './components/CricleChart';
import { RadarChart, sampleRadarData, defaultRadarOptions } from './components/RadarChart';
import TradingViewWidget, {Themes, BarStyles} from 'react-tradingview-widget';

import Statistics  from "./Statistics";
import Analytics from "./Analytics";
import Estimates from "./Estimates";
import News from "./News";
import Rating from "./Rating";
import Profile from "./Profile";

import { fetchQuotes } from "./Quote"; // ✅ Only addition


function mapSummaryData (data) {
  let summaryData = null;
  if (data !== null) { 
    summaryData = data.stock_rating[0];
    summaryData.GrowthScore = +4*data.stock_rating[0].GrowthScore;
    summaryData.ValuationScore = +4*data.stock_rating[0].ValuationScore;
    summaryData.ProfitabilityScore = +4*data.stock_rating[0].ProfitabilityScore;
    summaryData.StrengthScore = +4*data.stock_rating[0].StrengthScore;
    summaryData.SentimentScore = +4*data.stock_rating[0].SentimentScore;
    summaryData.MomentumScore = +4*data.stock_rating[0].MomentumScore;
    summaryData.TechnicalScore = +4*data.stock_rating[0].TechnicalScore;
  }
  return summaryData;
}




function mapRadarData (data) {
  let rData = sampleRadarData;

  if (data ) {
    rData = {
      labels: [
      'Growth',
      'Valuation',
      'Profitability',
      'Strength',
      'Sentiment',
      'Momentum'
      ],
      datasets: [{
        label: '',
        data: [data.stock_rating[0].GrowthScore, data.stock_rating[0].ValuationScore, data.stock_rating[0].ProfitabilityScore, data.stock_rating[0].StrengthScore, data.stock_rating[0].SentimentScore, data.stock_rating[0].MomentumScore],
        backgroundColor:  'rgba(94, 124, 235, 0.7)'
      }]
    };

  }
  return rData;
};


function StockDetails (props) {

  const [summaryData, setSummaryData] = useState(null);

  const [radarData, setRadarData] = useState(null);

  const {ticker} = useParams();

  const maxHeight = 250;
  const [maxWidth, setMaxWidth] = useState(620);

  const [windowDimension, setWindownDimensions]= useState ({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  })


  const detectSize = () => {
    setWindownDimensions({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    })

    if (window.innerWidth < 500){
      setMaxWidth(450);
    }
    else if (window.innerWidth >= 500 && window.innerWidth < 1199) {
      setMaxWidth(((window.innerWidth * 0.90)))
    }
    else {
      setMaxWidth(620);
    }
  }

  useLayoutEffect(() => {
    window.addEventListener('resize',detectSize)

    return() => {
      window.removeEventListener('resize', detectSize)
    }

  },[windowDimension])


  function fetchSummary(url) {
    const abortCtrl = new AbortController();

    const fetchData = async () => {
      console.log("fetching rating...");
      try {
        const response = await fetch(url, { signal: abortCtrl.signal });
        const json = await response.json();
        const mappedSummary = mapSummaryData(json);
        setSummaryData(mappedSummary);
        setRadarData(mapRadarData(json));
        console.log("fetch rating done");

        // ✅ After fetching summary, update price & change from latest quote
        if (mappedSummary?.Ticker) {
          const quotes = await fetchQuotes([mappedSummary.Ticker]);
          if (quotes && quotes.length > 0) {
            mappedSummary.Price = quotes[0].Price ?? mappedSummary.Price;
            mappedSummary.ChangeUSD = quotes[0].ChangeUSD ?? mappedSummary.ChangeUSD;
            setSummaryData({ ...mappedSummary }); // trigger re-render
          }
        }

      } catch (error) {
        if (error.name === 'AbortError') {
          console.log("aborted", error);
        } else {
          console.log("error", error);
        }
      }
    };
  
    fetchData();
    return () => abortCtrl.abort();
  }

  useEffect(() => {

    const server = "https://app.cuetraders.com";
    const url = server+"/api/get_stock_rating.php?ticker="+ticker ;
    fetchSummary(url);

  }, [ticker]);


/* alternatively use the custom hook useFetch */

/*
  const {data} = useFetch(url);
  if (data){  
        if(data.success){
          //  done
          summaryData = setRatingsData (data.stock_rating[0]);
          radarChartData = setRadarData(summaryData);
        }
        else {
          // data error
          console.log("Read Error"); 
        }
  }
  else {
    // log  data error
    console.log("Reading Details.. Returned null"); 
  }

 */


  return (<div className="content"> {summaryData && radarData && <div className="stock-details" align="center">
      <div className="col-lg-3 col-sm-6 col-xs-6">
         <h3>  {summaryData.CompanyName}</h3>
         <h3>{summaryData.Ticker}</h3>
         <div className="sm-frame3">
            <span className="sm-quote"> {summaryData.Price} </span>
               { (+summaryData.ChangeUSD >= 0) && <span className="sm-change-green">{summaryData.ChangeUSD}</span>}
               { (+summaryData.ChangeUSD < 0) &&  <span className="sm-change-red">({summaryData.ChangeUSD})</span>}
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 col-xs-6" align="center">
          <div>
            <i><Rating rating={(summaryData.Rating)}/></i>
            <h3> Score  </h3>
            <CircleChart score={Math.round(summaryData.AppScore)} size="100px" ></CircleChart>
            <br/>
          </div>
        </div>
        <div className="col-lg-6 col-sm-12 col-xs-12" >
        <div align="center" width="90%">
          <TradingViewWidget symbol={summaryData.Ticker} style={BarStyles.AREA} theme={Themes.LIGHT}  locale="en"   width={maxWidth} height={maxHeight}/>
        </div>
      </div>
      
      <div className="col-lg-12 col-sm-12 col-xs-12"> 
      <div className="col-lg-4 col-sm-4 col-xs-12"> 
          <h4> Quality Factors </h4>
          <div align="center">
              <RadarChart chartData={radarData} chartOptions={defaultRadarOptions}></RadarChart>
              <div className="panel-body">
                <div className="widget-tabs-2">
                <div className="l-span-xs-7"><div className="tab-2-title">Growth</div></div>
                  <div className="l-span-xs-5 tab-chart-wrapper">
                    <span data-percent="50" className="tabChart1 tab-chart"><CircleChart score={Math.round(summaryData.GrowthScore)} size="50px"></CircleChart></span>
                </div>
                <div className="l-span-xs-7"><div className="tab-2-title">Valuation</div></div>
                <div className="l-span-xs-5 tab-chart-wrapper">
                    <span data-percent="50" className="tabChart3 tab-chart"><CircleChart score={Math.round(summaryData.ValuationScore)} size="50px"></CircleChart></span>
                </div>
                <div className="l-span-xs-7"><div className="tab-2-title">Profitability</div></div>
                <div className="l-span-xs-5 tab-chart-wrapper">
                    <span data-percent="60" className="tabChart2 tab-chart"><CircleChart score={Math.round(summaryData.ProfitabilityScore)} size="50px"></CircleChart></span>
                </div>
                <div className="l-span-xs-7"><div className="tab-2-title">Strength</div></div>
                <div className="l-span-xs-5 tab-chart-wrapper">
                  <span data-percent="80" className="tabChart4 tab-chart"><CircleChart score={Math.round(summaryData.StrengthScore)} size="50px"></CircleChart></span>
                </div>
                <div className="l-span-xs-7"><div className="tab-2-title">Sentiment</div></div>
                <div className="l-span-xs-5 tab-chart-wrapper">
                  <span data-percent="10" className="tabChart5 tab-chart"><CircleChart score={Math.round(summaryData.SentimentScore)} size="50px"></CircleChart></span>
                </div>
                <div className="l-span-xs-7"><div className="tab-2-title">Momentum</div></div>
                <div className="l-span-xs-5 tab-chart-wrapper">
                  <span data-percent="10" className="tabChart5 tab-chart"><CircleChart score={Math.round(summaryData.MomentumScore)} size="50px"></CircleChart></span>
                </div>
              </div>
            </div>
          </div>
      </div>
      
      <Statistics ticker={ticker}/> 
 
      <Profile ticker={ticker}/>
      </div>

      <div className="col-lg-8 col-sm-7 col-xs-12"> 
      <News ticker={ticker}/>
      </div>

      <div className="col-lg-4 col-sm-5 col-xs-12">

      <Analytics ticker={ticker}/> 

      <Estimates ticker={ticker}/> 
  
      <div className="col-lg-12 col-sm-6 col-xs-12" align="left">
      <h4> Sponsered Ads </h4>
          <div>
            <ul className="list-style-type:disc">
                <li><i className="fa fa-ad"></i> <i>Sign up for Premium</i></li>
                <li><i className="fa fa-ad"></i> <i>Get access to our research and recommendations</i></li>
                <li><i className="fa fa-ad"></i> <i>Pay just $29 per month</i></li>
                <li><a href="/home.html">  Signup Now </a></li>
            </ul>
          </div>
          <div> --------------- </div>
          <div>
            <ul className="list-style-type:disc">
                <li><i className="fa fa-ad"></i> <i>Follow our Algo-Trading</i></li>
                <li><i className="fa fa-ad"></i> <i>Trade in your own Brokerage Account</i></li>
                <li><i className="fa fa-ad"></i> <i>Pay just $10 per trade</i></li>
                <li><a href="/home.html">  How it Works  </a></li>
            </ul>
            
          </div>
      </div>      
    </div>
  </div> }
  </div>);
}

export default StockDetails;